import { B2CPolicy, IEnvironmentVariables } from './IEnvironment';

export const b2cPolicies: B2CPolicy = {
  names: {
    signUpSignIn: 'B2C_1A_Signup_Signin',
    forgotPassword: 'B2C_1A_PasswordReset'
  },
  authorityBaseUrl: 'https://mncportaldev.b2clogin.com/tfp/mncportaldev.onmicrosoft.com'
};

export const environment: IEnvironmentVariables = {
  b2cPolicies: b2cPolicies,
  commonDomainEmailNoteReleaseDate: '2025-09-01T00:00:00Z',
  production: true,
  buildNumber: '_BUILDNUMBER_',
  version: '_VERSION_',
  baseUrl: 'https://usermgmt.portaldev.mynexuscare.com/',
  apiUrl: 'https://api-homehealth.portaldev.mynexuscare.com',
  platformApiUrl: 'https://api-platform.portaldev.mynexuscare.com',
  registryUrl: `https://api-platform.portaldev.mynexuscare.com/api/app-registry`,
  authConfig: {
    config: {
      auth: {
        clientId: 'fe9425ee-f357-42b9-829f-ba2f5e4fc23c',
        postLogoutRedirectUri: 'https://usermgmt.portaldev.mynexuscare.com/login',
        redirectUri: 'https://usermgmt.portaldev.mynexuscare.com/login',
        knownAuthorities: ['mncportaldev.b2clogin.com'],
        authority: `${b2cPolicies.authorityBaseUrl}/${b2cPolicies.names.signUpSignIn}`,
        navigateToLoginRequestUrl: false,
      },
    },
    angularConfig: {
      consentScopes: [
        'https://mncportaldev.onmicrosoft.com/api/api.Write',
        'https://mncportaldev.onmicrosoft.com/api/api.Read',
        'https://mncportaldev.onmicrosoft.com/api/user_impersonation',
      ],
      protectedResourceMap: [
        [
          'https://api-homehealth.portaldev.mynexuscare.com/',
          [
            'https://mncportaldev.onmicrosoft.com/api/api.Write',
            'https://mncportaldev.onmicrosoft.com/api/api.Read',
            'https://mncportaldev.onmicrosoft.com/api/user_impersonation',
          ]
        ],
        [
          'https://api-platform.portaldev.mynexuscare.com/',
          [
            'https://mncportaldev.onmicrosoft.com/api/api.Write',
            'https://mncportaldev.onmicrosoft.com/api/api.Read',
            'https://mncportaldev.onmicrosoft.com/api/user_impersonation',
          ]
        ]
      ]
    }
  }
};
